module.exports = __webpack_public_path__ + "img/sanroom2.b2c50e83.jpg";